<template>
    <div>
        <div class="acces">
            <img src="../assets/img/acces/bg-acces.svg" class="acces--bg" alt="" />
            <img src="../assets/img/acces/photo-opera.jpg" class="acces--opera rounded-circle" alt="" />

            <div class="container-lg d-flex flex-column py-5">
                <h1 class="text-white text-center text-400 mb-5">Accès & Infos pratiques</h1>

                <div class="row gy-4">
                    <div class="col-1 col-xl-1 text-center"></div>
                    <div class="col-11 col-md-auto d-flex flex-column">
                        <h4 class="text-400 mb-3">Coordonnées organisateurs</h4>
                        <div class="d-flex align-items-baseline">
                            <i class="fa-solid fa-user me-2--5"></i>
                            <div class="d-flex flex-column">
                                <b>Inès Royer</b>
                                <small>Chargée de communication MEDEF 21</small>
                            </div>
                        </div>
                        <div class="mt-2 d-flex align-items-center">
                            <i class="fa-solid fa-phone me-2--5"></i>
                            <a href="tel:+33779575729" class="text-white">+33(0)7 79 57 57 29</a>
                        </div>
                        <div class="mt-2 d-flex align-items-center">
                            <i class="fa-solid fa-envelope me-2--5"></i>
                            <a href="mailto:iroyer@medef21.fr" class="text-white">iroyer@medef21.fr</a>
                        </div>
                    </div>
                    <div class="col-1 col-xl-1"></div>
                    <div class="col-11 col-md-auto col-xl-6 d-flex flex-column">
                        <h4 class="text-400 mb-3">Adresse</h4>
                        <div class="d-flex">
                            <img src="../assets/img/acces/logo-opera.svg" class="acces--logo-opera me-2--5" alt="" />

                            <span>
                                <b class="mb-2">Auditorium de l'Opéra de Dijon</b>
                                <br />
                                Place Jean Bouhey
                                <br />
                                21000 Dijon
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="gmap text-center">
            <iframe
                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d1857.785540539967!2d5.050644332850169!3d47.32817976908385!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47f29dfc7a725911%3A0x1581ffea60fb3212!2sAuditorium%20Robert%20Poujade!5e0!3m2!1sfr!2sfr!4v1684766208825!5m2!1sfr!2sfr"
                width="100%"
                height="300"
                style="border: 0"
                allowfullscreen=""
                loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"
            ></iframe>

            <router-link class="btn btn-lg btn-dark text-400 fs-4 my-4" to="/billetterie"> BILLETTERIE </router-link>
        </div>
    </div>
</template>

<script>
export default {
    created() {},
    data() {
        return {};
    },
    props: {},
    methods: {},
};
</script>
